import {
  PaginatedData,
  PaginatedParams,
  FilterParams
} from "src/library/utils";
import {
  EndpointConfig,
  RequestConfig,
  UseApiRequest
} from "src/core/shared/api/config.api";
import useAxios from "src/core/shared/hooks/useAxios";
import { IProcessJob } from "src/core/process-job/api/processJobs.api";
import { IOrder } from "src/core/orders/api/orders.api";

// Entity types

export type ImportOrderParams = { orderReference: string; };

export interface IAPIOrderWithProcessJobError extends IOrder {
  processJob: IProcessJob<"api-export-order">
}

export type ListAPIExportIssuesParams = { pagination: PaginatedParams<IAPIOrderWithProcessJobError>; filters: FilterParams<IAPIOrderWithProcessJobError> };

export type ListAPIImportIssuesParams = { pagination: PaginatedParams<IProcessJob>; filters: FilterParams<IProcessJob> };
type APIEndpointConfig = {
  IMPORT_API_ORDER: EndpointConfig<
  ImportOrderParams,
  IProcessJob
  >;
  LIST_ORDER_IMPORT_ISSUES: EndpointConfig<
  ListAPIImportIssuesParams,
  PaginatedData<IProcessJob>
  >;
  LIST_ORDER_EXPORT_ISSUES: EndpointConfig<
  ListAPIExportIssuesParams,
  PaginatedData<IAPIOrderWithProcessJobError>
  >;
  BULK_HANDLE_API_ISSUE: EndpointConfig<
  { processJobIds: number[], action: "export" | "retry" | "ignore" },
  { failed: number; queued: number; }
  >;
  RETRY_API_JOB: EndpointConfig<
  { processJobId: number },
  IProcessJob
  >;
  IMPORT_API_CUSTOMER: EndpointConfig<
  { customerCode: string },
  IProcessJob
  >;
  IMPORT_API_PRODUCT: EndpointConfig<
  { partNumber: string },
  IProcessJob
  >;
};

// connector api specific logic

const BASE_URL = `${process.env.REACT_APP_API_URL}/connector`;

const requests: RequestConfig<APIEndpointConfig> = {
  LIST_ORDER_EXPORT_ISSUES: params => ({
    url: `${BASE_URL}/orders/export-issues`,
    method: "GET",
    params
  }),
  LIST_ORDER_IMPORT_ISSUES: params => ({
    url: `${BASE_URL}/orders/import-issues`,
    method: "GET",
    params
  }),
  IMPORT_API_ORDER: ({ orderReference }) => ({
    url: `${BASE_URL}/import-order/${orderReference}`,
    method: "GET"
  }),
  BULK_HANDLE_API_ISSUE: data => ({
    url: `${BASE_URL}/bulk-handle-issues`,
    method: "POST",
    data
  }),
  RETRY_API_JOB: data => ({
    url: `${BASE_URL}/retry-job/${data.processJobId}`,
    method: "POST",
    data
  }),
  IMPORT_API_CUSTOMER: data => ({
    url: `${BASE_URL}/import-customer`,
    method: "POST",
    data
  }),
  IMPORT_API_PRODUCT: data => ({
    url: `${BASE_URL}/import-product`,
    method: "POST",
    data
  })
};

export const useConnectorApi: UseApiRequest<APIEndpointConfig> = name => useAxios(requests[ name ], name);
